import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FOR_INVESTORS_SECTIONS } from 'constants/businessToolSections/forInvestors';

import { TextInputControl } from 'components/_basic/Form/TextInput';
import { FormHeader } from 'components/_basic/FormHeader/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';
import {
  EXECUTIVE_SUMMARY_ORGANIZATION_AND_TEAM_NAMES,
  prefix,
} from 'components/BusinessToolForm/Sections/ExecutiveSummary/TeamExecSummary/utils/form';

import { concatWithDot } from 'helpers/string';

export const OrganizationExecSum: React.FC = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const canAccess = true;
  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t('executiveSummary.title')}
          badgeText={t('executiveSummary.team.title')}
          section={FOR_INVESTORS_SECTIONS.EXECUTIVE_SUMMARY}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('executiveSummary.team.teamMembers')}
        aiFieldName={concatWithDot(prefix, EXECUTIVE_SUMMARY_ORGANIZATION_AND_TEAM_NAMES.MEMBERS)}
      >
        {/* 1.5.1 */}
        <TextInputControl
          multiline
          control={control}
          id="executiveSummary.team.teamMembers"
          name={concatWithDot(prefix, EXECUTIVE_SUMMARY_ORGANIZATION_AND_TEAM_NAMES.MEMBERS)}
          minRows={3}
          disabled={!canAccess}
          maxLength={1000}
        />
      </FormSectionCard>
    </>
  );
};
